import { screen } from '@/router/screenRoutes';

// import store from '@/stores';

// B2B-185: fila de leads de leilão — restrita ao Master/Admin da promotora.
// Confirmar com backend/produto os role_ids exatos de "Admin" da promotora
// (hoje usa admin(1)/master(18)/managerMaster(23), ver isPromotoraMasterOrAdmin).
// const AUCTION_LEADS_ALLOWED_ROLES = [1, 18, 23];

export default [
  // routes
  {
    ...screen('worker-credit-proposal'),
    component: () => import('@/views/workerCredit/WorkerCreditList.vue'),
  },
  {
    ...screen('worker-credit-proposal-action'),
    component: () => import('@/views/workerCredit/action/ListView.vue'),
  },
  {
    ...screen('worker-credit-auction-leads'),
    component: () => import('@/views/workerCredit/AuctionLeadsList.vue'),
  },
  {
    ...screen('worker-credit-consult'),
    component: () => import('@/views/workerCredit/WorkerCreditConsult.vue'),
  },
  {
    ...screen('worker-credit-new'),
    component: () => import('@/views/workerCredit/WorkerCreditNewProposal.vue'),
  },
  {
    ...screen('worker-credit-contract-management'),
    component: () => import('@/views/workerCredit/WorkerCreditContractManagement.vue'),
  },
  {
    ...screen('worker-credit-contract-management-details'),
    component: () => import('@/views/workerCredit/WorkerCreditContractManagementDetails.vue'),
  },
  {
    ...screen('worker-credit-contract-management-companies'),
    component: () => import('@/views/workerCredit/WorkerCreditListCompany.vue'),
  },
  {
    ...screen('worker-credit-contract-debt-collection'),
    component: () => import('@/views/workerCredit/WorkerCreditContractDebtCollection.vue'),
  },
  {
    ...screen('worker-credit-contract-debt-collection-details'),
    component: () => import('@/views/workerCredit/WorkerCreditContractDebtCollectionDetails.vue'),
  },
  {
    ...screen('worker-credit-collection-management'),
    component: () => import('@/views/workerCredit/WorkerCreditCollectionManagement.vue'),
  },

  // redirects (legacy)
  {
    path: '/propostas/consignado-privado',
    redirect: { name: 'worker-credit-proposal' },
  },
  {
    path: '/cpr/propostas',
    redirect: { name: 'worker-credit-proposal' },
  },
  {
    path: '/cpr/consultar',
    redirect: { name: 'worker-credit-consult' },
  },
  {
    path: '/cpr/novo',
    redirect: { name: 'worker-credit-new' },
  },
  {
    path: '/credito-trabalhador/propostas',
    redirect: { name: 'worker-credit-proposal' },
  },
  {
    path: '/credito-trabalhador/consultar',
    redirect: { name: 'worker-credit-consult' },
  },
  {
    path: '/credito-trabalhador/novo',
    redirect: { name: 'worker-credit-new' },
  },
];
